import { render, staticRenderFns } from "./IntegrateDataView.vue?vue&type=template&id=27320a76&"
import script from "./IntegrateDataView.vue?vue&type=script&lang=js&"
export * from "./IntegrateDataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports